<template>
  <div>
    <div class="footer" v-if="currentPath == 2" :class="[addClassHome ? 'addClassHome' : '']">
      <footerCont />
    </div>
    <div v-else>
      <div class="footer" v-if="currentPath == 3" :style="{ width: screenWidth, float: 'right' }" :class="[addClass ? 'addClass' : '']">
          <footerCont />
      </div>
    </div>
  </div>
</template>

<script>
import footerCont from '@/components/Footer/footerCont.vue'
export default {
  name:'FooterBar',
  props: {},
  components: {
    footerCont,
  },
  mounted() {
    document.addEventListener('click', (e) => {
      let left = document.getElementById('left-arrow')
      let right = document.getElementById('right-arrow')
      if (left && (left.contains(e.target) || left == e.target)) {
        //计算当前宽度
        this.screenWidth = document.documentElement.clientWidth - 70 + 'px'
      }
      if (right && (right.contains(e.target) || right == e.target)) {
        if (this.$route.path.includes('/product/detail') || this.$route.path.includes('/trade/result')) {
          this.screenWidth = document.documentElement.clientWidth - 268 + 'px'
        } else {
          this.screenWidth = document.documentElement.clientWidth - 200 + 'px'
        }
      }
    })
  },
  computed: {
    // 当前路由路径
    currentPath() {
      if (this.$route.path.includes('/product/detail') || this.$route.path.includes('/trade/result')) {
        this.screenWidth = document.documentElement.clientWidth - 268 + 'px'
      } else {
        this.screenWidth = document.documentElement.clientWidth - 200 + 'px'
      }
      if (this.$route.path == '/company/result' || this.$route.path == '/business/result' || this.$route.path == '/intelligence' || this.$route.path == '/home' || this.$route.path == '/company/cantonFair') {
        //添加样式
        this.addClass = true
        this.addClassHome = true
        this.$forceUpdate()
      } else {
        this.addClass = false
        this.addClassHome = false
      }
      if (this.$route.path.includes('/intelligence') || this.$route.path.includes('/product/detai') || this.$route.path.includes('/company/detail')) {
        return 3
      }
      // 如果包含/AIGPT
      if(this.$route.path.includes('/aigpt')) {
        return 1
      }
      let length = this.$route.path.split('/').length
      if (length == 3) {
        //二级路由要显示的
        if( this.$route.path.includes('/trade/result')||this.$route.path.includes('focusOnCollectionDetail')||this.$route.path.includes('downloadCenter')) {
          return 2
        }
        if (this.$route.path.includes('/company/detail') || this.$route.path.includes('/product/detail')) {
          return 3
        } else {
          return 1
        }
      } else {
        return 2
      }
    },
  },
  data() {
    return {
      screenWidth: null,
      marginWidth: null,
      addClass: false,
      addClassHome: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.addClass {
  padding-bottom: 78px;
}
.addClassHome {
  padding-bottom: 66px;
}
</style>